import{jsx as t,jsxs as i}from"react/jsx-runtime";import{styled as o}from"@mui/joy";import r from"@mui/joy/Button";import n from"@mui/joy/Skeleton";var a=o(n)`
  position: absolute;
  inset: 0;
  border-radius: 5px;
  .MuiButton-variantOutlined &,
  .MuiButtonGroup-variantOutlined & {
    inset: -1px;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
  }
`,e=({children:o,skeleton:n,variant:e,...s})=>i(r,{...s,variant:e,children:[n&&t(a,{}),o]});export{e as Button,a as ButtonSkeleton};
//# sourceMappingURL=ButtonWithSkeleton.js.map